  (function () {
    var config = document.currentScript && document.currentScript.dataset;
    if (!config) return;
    var sectionId = config.zehnSectionId;
    var root = document.getElementById('ZehnHeader-' + sectionId);
    if (!root) return;

    window.__zehnHeaders = window.__zehnHeaders || {};
    if (window.__zehnHeaders[sectionId]) {
      window.__zehnHeaders[sectionId]();
    }

    var nav = root.querySelector('[data-zh-nav]');
    var burger = root.querySelector('[data-zh-menu-toggle]');
    var mobile = root.querySelector('[data-zh-mobile]');
    var mobileInner = root.querySelector('[data-zh-mobile-inner]');
    var dropdown = root.querySelector('[data-zh-dropdown]');
    var linkRow = root.querySelector('[data-zh-desktop-links]');
    var triggers = root.querySelectorAll('[data-zh-trigger]');
    var panels = root.querySelectorAll('[data-zh-panel]');

    var WISHLIST_KEY = config.wishlistKey || '';
    var WISHLIST_LABEL = config.wishlistLabel || 'Wunschliste';
    var OPEN_POPUP = config.wishlistPopup === 'true';

    var closeDelay = Number(config.closeDelay) || 0;
    var closeTimer = null;
    var resetTimer = null;
    var menuEndTimer = null;
    var activePanel = null;

    /* ---------- accordions ---------- */
    function setAccordion(toggle, open) {
      var body = document.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.classList.toggle('is-open', open);
      if (toggle.dataset.labelOpen) {
        toggle.setAttribute(
          'aria-label',
          open ? toggle.dataset.labelClose : toggle.dataset.labelOpen,
        );
      }
    }

    function closeAccordionsIn(scope) {
      if (!scope) return;
      scope.querySelectorAll('[data-zh-acc-toggle][aria-expanded="true"]').forEach(function (t) {
        setAccordion(t, false);
      });
    }

    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-zh-acc-toggle]');
      if (!toggle || !root.contains(toggle)) return;

      event.preventDefault();
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';

      // One open sibling per group, matching the single-value React state.
      var group = toggle.getAttribute('data-zh-group');
      if (group && !isOpen) {
        root
          .querySelectorAll('[data-zh-group="' + group + '"][aria-expanded="true"]')
          .forEach(function (t) {
            if (t !== toggle) setAccordion(t, false);
          });
      }

      setAccordion(toggle, !isOpen);
    });

    /* ---------- desktop dropdown ---------- */
    function cancelClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = null;
    }

    function closeDropdown() {
      cancelClose();
      if (!dropdown) return;
      dropdown.classList.remove('is-open');
      dropdown.setAttribute('aria-hidden', 'true');
      triggers.forEach(function (t) {
        if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false');
      });

      // Hold the position and the open panel until the card has faded out.
      // Resetting them immediately would collapse the content and snap the
      // panel back to the left edge mid-animation.
      if (resetTimer) clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        resetTimer = null;
        if (dropdown.classList.contains('is-open')) return;
        dropdown.style.left = '0';
        dropdown.style.transform = 'none';
        closeAccordionsIn(dropdown);
        panels.forEach(function (p) {
          p.classList.remove('is-active');
        });
        activePanel = null;
      }, 260);
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(closeDropdown, closeDelay);
    }

    function openDropdown(trigger) {
      if (!dropdown) return;
      var key = trigger.getAttribute('data-zh-trigger');
      var panel = root.querySelector('[data-zh-panel="' + key + '"]');
      if (!panel) {
        closeDropdown();
        return;
      }

      cancelClose();
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
      }

      if (activePanel !== panel) {
        closeAccordionsIn(dropdown);
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p === panel);
        });
        triggers.forEach(function (t) {
          if (t.hasAttribute('aria-expanded')) {
            t.setAttribute('aria-expanded', t === trigger ? 'true' : 'false');
          }
        });
        activePanel = panel;
      }

      dropdown.classList.add('is-open');
      dropdown.setAttribute('aria-hidden', 'false');

      // Centre the panel under the hovered link.
      var navRect = nav.getBoundingClientRect();
      var itemRect = trigger.getBoundingClientRect();
      dropdown.style.left = itemRect.left + itemRect.width / 2 - navRect.left + 'px';
      dropdown.style.transform = 'translateX(-50%)';
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        openDropdown(trigger);
      });
      trigger.addEventListener('focus', function () {
        openDropdown(trigger);
      });
      trigger.addEventListener('click', closeDropdown);
    });

    if (linkRow) {
      linkRow.addEventListener('mouseenter', cancelClose);
      linkRow.addEventListener('mouseleave', scheduleClose);
    }

    if (dropdown) {
      dropdown.addEventListener('mouseenter', cancelClose);
      dropdown.addEventListener('mouseleave', scheduleClose);
    }

    /* ---------- mobile drawer ---------- */
    // Real content height, capped at 75vh, including the inner's bottom margin.
    function menuTarget() {
      var natural = mobileInner ? mobileInner.offsetHeight + 16 : mobile.scrollHeight;
      return Math.min(natural, Math.round(window.innerHeight * 0.75));
    }

    function setMenu(open) {
      if (!burger || !mobile) return;

      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute(
        'aria-label',
        open ? burger.dataset.labelClose : burger.dataset.labelOpen,
      );

      if (menuEndTimer) {
        clearTimeout(menuEndTimer);
        menuEndTimer = null;
      }

      // Always animate from the height on screen right now, so an interrupted
      // open/close picks up where it was instead of restarting.
      mobile.style.overflowY = 'hidden';
      mobile.style.maxHeight = mobile.getBoundingClientRect().height + 'px';
      void mobile.offsetHeight;

      if (open) {
        mobile.classList.add('is-open');
        mobile.style.maxHeight = menuTarget() + 'px';
        menuEndTimer = setTimeout(function () {
          menuEndTimer = null;
          if (!mobile.classList.contains('is-open')) return;
          // Hand the height back to the content so accordions expand freely.
          mobile.style.maxHeight = '75vh';
          mobile.style.overflowY = 'auto';
        }, 460);
      } else {
        mobile.classList.remove('is-open');
        mobile.style.maxHeight = '0px';
        closeAccordionsIn(mobileInner);
      }
    }

    if (burger) {
      burger.addEventListener('click', function () {
        setMenu(burger.getAttribute('aria-expanded') !== 'true');
      });
    }

    root.querySelectorAll('[data-zh-close-menu]').forEach(function (el) {
      el.addEventListener('click', function () {
        setMenu(false);
      });
    });

    /* ---------- outside click + escape ---------- */
    function onPointerDown(event) {
      var target = event.target;
      if (dropdown && dropdown.classList.contains('is-open')) {
        var inRow = linkRow && linkRow.contains(target);
        if (!dropdown.contains(target) && !inRow) closeDropdown();
      }
      if (mobile && mobile.classList.contains('is-open')) {
        var onBurger = burger && burger.contains(target);
        if (!mobile.contains(target) && !onBurger) setMenu(false);
      }
    }

    function onKeyDown(event) {
      if (event.key !== 'Escape') return;
      closeDropdown();
      setMenu(false);
    }

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('touchstart', onPointerDown, {passive: true});
    document.addEventListener('keydown', onKeyDown);

    /* ---------- search + cart triggers ---------- */
    // If the drawer/modal section is on the page it gets the event.
    // If it isn't installed yet, go to the normal page instead.
    function openOverlay(selector, eventName, fallbackUrl) {
      if (document.querySelector(selector)) {
        document.dispatchEvent(new CustomEvent(eventName, {bubbles: true}));
      } else {
        window.location.href = fallbackUrl;
      }
    }

    root.querySelectorAll('[data-zh-search]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMenu(false);
        openOverlay('[data-zehn-search-modal]', 'zehn:search:open', config.searchUrl || '/search');
      });
    });

    root.querySelectorAll('[data-zh-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMenu(false);
        openOverlay('[data-zehn-cart-drawer]', 'zehn:cart:open', config.cartUrl || '/cart');
      });
    });

    /* ---------- counts ----------
       data-zh-count on the button is what the CSS above keys off, so painting
       it is the whole "change the design" step: 0 -> outline heart, anything
       else -> filled accent heart + badge (+ the burger dot on mobile). */
    var wishlistCount = -1;

    function paint(selector, countEl, count) {
      root.querySelectorAll(selector).forEach(function (el) {
        el.setAttribute('data-zh-count', String(count));
        var badge = el.querySelector(countEl);
        if (badge) badge.textContent = count > 9 ? '9+' : String(count);
      });
    }

    function setCartCount(count) {
      paint('[data-zh-cart]', '[data-zh-cart-count]', Number(count) || 0);
    }

    function setWishlistCount(count) {
      count = Number(count) || 0;
      if (count === wishlistCount) return;
      wishlistCount = count;

      paint('[data-zh-wishlist]', '[data-zh-wishlist-count]', count);

      var dot = root.querySelector('[data-zh-wishlist-dot]');
      if (dot) dot.hidden = count === 0;

      root.querySelectorAll('[data-zh-wishlist]').forEach(function (el) {
        el.setAttribute(
          'aria-label',
          count === 0 ? WISHLIST_LABEL : WISHLIST_LABEL + ' (' + count + ')',
        );
      });
    }

    /* ---------- where the wishlist count comes from ----------
       Wishlist Hero stores the list on its own servers, so there is nothing in
       localStorage to read. Its SDK lands on window.WishListHero_SDK once the
       app embed boots and announces itself with wishlist-hero-wishlist-sdk-ready.
       GetWishListItemsCount() returns a promise. */
    function wishlistHeroSdk() {
      var sdk = window.WishListHero_SDK;
      return sdk && typeof sdk.GetWishListItemsCount === 'function' ? sdk : null;
    }

    // Fallback only: a self-hosted wishlist that writes to localStorage. Handles
    // an array of objects, an array of ids, or an id-keyed object, without
    // counting the same product twice.
    function countStored(value) {
      if (Array.isArray(value)) {
        var seen = {};
        var total = 0;
        for (var i = 0; i < value.length; i++) {
          var item = value[i];
          var key;
          if (item && typeof item === 'object') {
            key = item.variantId || item.id || item.handle || JSON.stringify(item);
          } else {
            key = String(item);
          }
          if (!seen[key]) {
            seen[key] = true;
            total++;
          }
        }
        return total;
      }
      if (value && typeof value === 'object') return Object.keys(value).length;
      return 0;
    }

    function readStored() {
      if (!WISHLIST_KEY) return 0;
      try {
        var raw = localStorage.getItem(WISHLIST_KEY);
        return raw ? countStored(JSON.parse(raw)) : 0;
      } catch (e) {
        return 0;
      }
    }

    // Resolves to a number, or to null when the answer is unknown (SDK threw or
    // rejected) — null leaves whatever is on screen alone rather than blanking
    // a good count back to the empty heart.
    function readWishlistCount() {
      var sdk = wishlistHeroSdk();
      if (!sdk) return Promise.resolve(readStored());
      try {
        return Promise.resolve(sdk.GetWishListItemsCount()).then(
          function (value) {
            return Number(value) || 0;
          },
          function () {
            return null;
          },
        );
      } catch (e) {
        return Promise.resolve(null);
      }
    }

    var refreshTimer = null;
    var refreshInFlight = false;
    var refreshPending = false;

    function runRefresh() {
      if (refreshInFlight) {
        refreshPending = true;
        return;
      }
      refreshInFlight = true;
      readWishlistCount().then(function (count) {
        refreshInFlight = false;
        if (count !== null) setWishlistCount(count);
        if (refreshPending) {
          refreshPending = false;
          scheduleRefresh(150);
        }
      });
    }

    // Debounced: one add can fire a class flip, a DOM insert and a click all in
    // the same tick, and that should cost one SDK call, not three.
    function scheduleRefresh(delay) {
      if (refreshTimer) clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        refreshTimer = null;
        runRefresh();
      }, delay || 0);
    }

    // Wishlist Hero's write is a round trip, so re-read a few times after an
    // interaction instead of trusting one immediate answer.
    var burstTimers = [];
    function burstRefresh() {
      [250, 900, 2000].forEach(function (delay) {
        burstTimers.push(
          setTimeout(function () {
            runRefresh();
          }, delay),
        );
      });
    }

    /* ---------- what tells us the wishlist changed ----------
       Wishlist Hero fires no "item added" event, but it does toggle
       wishlisthero-product-in-wishlist on its own buttons and rebuilds its
       popup — both are DOM changes we can watch. */
    var HERO_CLASS = /wishlist-?hero/i;

    function touchesWishlistHero(node) {
      if (!node || node.nodeType !== 1) return false;
      var cls = node.getAttribute ? node.getAttribute('class') : null;
      return !!cls && HERO_CLASS.test(cls);
    }

    var observer = null;
    if (typeof MutationObserver === 'function') {
      observer = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var record = records[i];
          if (touchesWishlistHero(record.target)) {
            scheduleRefresh(250);
            return;
          }
          for (var j = 0; j < record.addedNodes.length; j++) {
            if (touchesWishlistHero(record.addedNodes[j])) {
              scheduleRefresh(250);
              return;
            }
          }
          for (var k = 0; k < record.removedNodes.length; k++) {
            if (touchesWishlistHero(record.removedNodes[k])) {
              scheduleRefresh(250);
              return;
            }
          }
        }
      });
      observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    function onDocumentClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('[class*="wishlisthero"], [class*="wishlist-hero"]')) {
        burstRefresh();
      }
    }

    function onSdkReady() {
      scheduleRefresh(0);
      burstRefresh();
    }

    function onCartUpdated(event) {
      if (event.detail && typeof event.detail.count !== 'undefined') {
        setCartCount(event.detail.count);
      }
    }

    // Kept for a self-hosted wishlist, and so anything in the theme can push a
    // count straight in: document.dispatchEvent(new CustomEvent(
    //   'zehn:wishlist:updated', {detail: {count: 3}}))
    function onWishlistUpdated(event) {
      if (event.detail && typeof event.detail.count !== 'undefined') {
        setWishlistCount(event.detail.count);
      } else {
        scheduleRefresh(0);
      }
    }

    function onNativeStorage(event) {
      if (!WISHLIST_KEY) return;
      if (!event.key || event.key === WISHLIST_KEY) scheduleRefresh(0);
    }

    function onVisible() {
      if (!document.hidden) scheduleRefresh(0);
    }

    document.addEventListener('wishlist-hero-wishlist-sdk-ready', onSdkReady);
    document.addEventListener('zehn:wishlist:updated', onWishlistUpdated);
    document.addEventListener('zehn:wishlist:changed', onWishlistUpdated);
    document.addEventListener('wishlist:updated', onWishlistUpdated);
    document.addEventListener('zehn:cart:updated', onCartUpdated);
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('storage', onNativeStorage);
    window.addEventListener('pageshow', function () {
      scheduleRefresh(0);
    });

    // The app embed can boot after this script runs and after its ready event,
    // so poll gently for the SDK on first load, then keep a slow backstop.
    var bootTries = 0;
    var bootTimer = setInterval(function () {
      bootTries++;
      if (wishlistHeroSdk()) {
        clearInterval(bootTimer);
        bootTimer = null;
        scheduleRefresh(0);
      } else if (bootTries > 20) {
        clearInterval(bootTimer);
        bootTimer = null;
      }
    }, 500);

    var pollTimer = setInterval(function () {
      if (!document.hidden) scheduleRefresh(0);
    }, 15000);

    scheduleRefresh(0);

    /* ---------- header button opens the Wishlist Hero popup ---------- */
    if (OPEN_POPUP) {
      root.querySelectorAll('[data-zh-wishlist]').forEach(function (el) {
        el.addEventListener('click', function (event) {
          var sdk = window.WishListHero_SDK;
          if (!sdk || typeof sdk.OpenWishList !== 'function') return;
          event.preventDefault();
          setMenu(false);
          sdk.OpenWishList();
          burstRefresh();
        });
      });
    }

    window.ZehnHeader = {
      setCartCount: setCartCount,
      setWishlistCount: setWishlistCount,
      refreshWishlist: function () {
        scheduleRefresh(0);
      },
      closeMenu: function () {
        setMenu(false);
        closeDropdown();
      },
    };

    /* ---------- teardown (theme editor reloads) ---------- */
    window.__zehnHeaders[sectionId] = function () {
      cancelClose();
      if (resetTimer) clearTimeout(resetTimer);
      if (menuEndTimer) clearTimeout(menuEndTimer);
      if (refreshTimer) clearTimeout(refreshTimer);
      if (bootTimer) clearInterval(bootTimer);
      if (pollTimer) clearInterval(pollTimer);
      burstTimers.forEach(clearTimeout);
      if (observer) observer.disconnect();
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('touchstart', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('wishlist-hero-wishlist-sdk-ready', onSdkReady);
      document.removeEventListener('zehn:wishlist:updated', onWishlistUpdated);
      document.removeEventListener('zehn:wishlist:changed', onWishlistUpdated);
      document.removeEventListener('wishlist:updated', onWishlistUpdated);
      document.removeEventListener('zehn:cart:updated', onCartUpdated);
      document.removeEventListener('click', onDocumentClick, true);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('storage', onNativeStorage);
    };
  })();
